export default __webpack_public_path__ + "static/media/GroupRemove.fe45c2ef.svg";